"use client";

import StyledIcon from "@litonarefin/components/StyledIcon";
import { cn } from "@litonarefin/utils";
import { getSourceSite } from "@litonarefin/utils/getSourceSite";
import { getIcon } from "@litonarefin/utils/icons";
import { usePathname } from "next/navigation";
import React, { useState, useEffect } from "react";

const siteSource = getSourceSite();

const SideTableOfContent = () => {
  const [activeContent, setActiveContent] = useState(true);
  const [headings, setHeadings] = useState([]);
  const [show, setShow] = useState(false);

  const pathname = usePathname();

  // Scroll Percentage
  const scrollPercentage = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = (winScroll / height) * 150;

    if (scrolled && scrolled > 10) {
      setShow(true);
    } else {
      setShow(false);
    }
  };

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".jlt-blog-content h2")).map(
      (elem, i) => {
        if (!elem.getAttribute("id")) {
          elem.setAttribute("id", `heading_${++i}`);
        }
        return {
          id: elem.id,
          text: elem.innerText,
        };
      }
    );
    setHeadings(elements);

    //Add Body Class
    // let reload = false;
    // let timeOut;

    // const body = document.body;
    // body.classList.add("jlt-table-of-content");

    // timeOut = setTimeout(() => {
    //   reload = true;
    // }, 1);

    // Show Hide Table of Content
    const isHiddenData = localStorage.getItem(`${siteSource}_blog_t_content`);
    if (isHiddenData) {
      const isHidden = JSON.parse(isHiddenData);
      if (isHidden && activeContent) {
        setActiveContent(false);
      }
    }

    window.addEventListener("scroll", scrollPercentage);

    return () => {
      window.removeEventListener("scroll", scrollPercentage);

      // if (reload) {
      //   clearTimeout(timeOut);
      //   body.classList.remove("jlt-table-of-content");
      // }
    };
  }, []);

  // if (!show) return "";
  if (!headings?.length) return;

  return (
    <div className="mb-3">
      <h4 className="jlt-text-[18px] jlt-font-bold jlt-text-foreground jlt-leading-5 jlt-mb-4">
        Table of Contents
      </h4>

      <ul className="jlt-pr-3 jlt-max-h-[220px] jlt-overflow-x-hidden jlt-overflow-y-auto [&::-webkit-scrollbar]:jlt-w-1 [&::-webkit-scrollbar]:jlt-bg-gray-100 [&::-webkit-scrollbar-thumb]:jlt-bg-gray-300 jlt-flex jlt-flex-col jlt-gap-2">
        {headings.map((heading) => (
          <li
            key={heading.id}
            className="jlt-pl-3 jlt-pr-2 jlt-text-[12px] jlt-font-medium jlt-leading-[16px] jlt-text-foreground before:jlt-content-['-_']"
          >
            <a
              href={`#${heading.id}`}
              className="jlt-select-none hover:jlt-text-[var(--primary)] jlt-transition-all jlt-duration-150 hover:jlt-underline"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector(`#${heading.id}`).scrollIntoView({
                  behavior: "smooth",
                });
              }}
            >
              {heading.text}
            </a>
          </li>
        ))}
      </ul>

      {headings ? (
        <script
          type="application/ld+json"
          id="blog_table_of_content"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org","@type": "ItemList","name": "Table of Contents","itemListElement": ${getTableOfContentItems(
              headings,
              pathname
            )}
            }`,
          }}
        />
      ) : null}
    </div>
  );

  return (
    <div
      className="jlt-hidden jlt-absolute jlt-top-0 -jlt-left-72 md:jlt-flex jlt-flex-col jlt-h-full jlt-z-[9999] table-of-content"
      style={{
        display: !show ? "none" : "flex",
      }}
    >
      <div
        className={`jlt-sticky jlt-top-0 jlt-h-max jlt-right-auto jlt-hidden md:jlt-block ${
          activeContent ? "jlt-left-0 jlt-top-16" : "-jlt-left-[250px] jlt-top-0"
        } jlt-w-[250px] jlt-z-[999999999]`}
        // style={{ transition: "all 0.4s" }}
        // className="jlt-sticky jlt-top-0 -jlt-left-28 jlt-bottom-0"
      >
        <div
          className={cn(
            "jlt-relative jlt-flex jlt-justify-end",
            activeContent ? "jlt-items-start jlt-top-0 jlt-h-auto" : "jlt-items-center jlt-top-20"
          )}
        >
          <button
            type="button"
            className={`jlt-flex jlt-items-center ${activeContent ? "" : ""}`}
            onClick={() => {
              setActiveContent(!activeContent);
              localStorage.removeItem(`${siteSource}_blog_t_content`);
            }}
            // style={{ transition: "all 0.3s" }}
          >
            {activeContent ? null : (
              <div className="jlt-flex jlt-items-center jlt-justify-center jlt-p-2 jlt-bg-white jlt-border jlt-rounded-md">
                <span
                  className={`${activeContent ? "jlt-rotate-[180deg]" : "jlt-rotate-[0deg]"}`}
                  style={{ transition: "all 0.3s" }}
                >
                  <StyledIcon styles={{ stroke: "#171717", width: "22px", height: "22px" }}>
                    {getIcon("tableOfContent")}
                  </StyledIcon>
                </span>
              </div>
            )}
          </button>

          {activeContent ? (
            <div
              className={cn(
                "jlt-relative jlt-border jlt-border-border  jlt-w-full jlt-shadow-md jlt-rounded-l-md jlt-py-5 jlt-px-3 jlt-z-50",
                siteSource === "wpspotlight" ? "jlt-bg-[#262626]" : "jlt-bg-white"
              )}
            >
              <span
                onClick={() => {
                  setActiveContent(false);
                  localStorage.setItem(`${siteSource}_blog_t_content`, true);
                }}
                style={{ transition: "all 0.3s" }}
                className="jlt-bg-[#FCFDFF] jlt-border jlt-border-l-0 jlt-rounded-tr-[3px] jlt-rounded-br-[3px] jlt-absolute -jlt-right-[25px] jlt-top-[16px] jlt-cursor-pointer jlt-p-1"
              >
                <StyledIcon
                  styles={{
                    stroke: "#171717",
                    width: "16px",
                    height: "16px",
                    padding: "2px",
                    transform: "rotate(180deg)",
                  }}
                >
                  {getIcon("leftArrow")}
                </StyledIcon>
              </span>

              <h4 className="jlt-text-[18px] jlt-font-bold jlt-text-foreground jlt-leading-5 jlt-mb-4">
                Table of Contents
              </h4>

              <ul className="jlt-pr-3 jlt-overflow-x-hidden jlt-overflow-y-auto [&::-webkit-scrollbar]:jlt-w-1 [&::-webkit-scrollbar]:jlt-bg-gray-100 [&::-webkit-scrollbar-thumb]:jlt-bg-gray-300 jlt-flex jlt-flex-col jlt-gap-2">
                {headings.map((heading) => (
                  <li
                    key={heading.id}
                    className="jlt-pl-3 jlt-pr-2 jlt-text-[10px] jlt-font-medium jlt-leading-[16px] jlt-text-foreground before:jlt-content-['-_']"
                  >
                    <a
                      href={`#${heading.id}`}
                      className="jlt-select-none hover:jlt-text-[var(--primary)] jlt-transition-all jlt-duration-150 hover:jlt-underline"
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector(`#${heading.id}`).scrollIntoView({
                          behavior: "smooth",
                        });
                      }}
                    >
                      {heading.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ) : null}
        </div>

        {headings ? (
          <script
            type="application/ld+json"
            id="blog_table_of_content"
            dangerouslySetInnerHTML={{
              __html: `{"@context": "https://schema.org","@type": "ItemList","name": "Table of Contents","itemListElement": ${getTableOfContentItems(
                headings,
                pathname
              )}
            }`,
            }}
          />
        ) : null}
      </div>
    </div>
  );
};

function getTableOfContentItems(headings, pathname) {
  const items = headings.map((heading, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: heading.text,
    url: `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}#${heading.id}`,
  }));

  return JSON.stringify(items);
}

export default SideTableOfContent;
